import { useContext } from "react";
import {
  IFilterPlanProps,
  IFilterPlansProps,
  IPlan,
  IPlanParent,
} from "./types";
import { PlansContext } from "./context";
import { filterPlans } from "./utils";

export function usePlans(filters?: IFilterPlansProps): IPlan[] {
  const { plans } = useContext(PlansContext);

  if (filters) {
    return filterPlans(plans, filters);
  }

  return plans;
}

export function usePlan({
  alias: planAlias,
}: IFilterPlanProps): IPlan | undefined {
  const { plans } = useContext(PlansContext);
  return plans.find(({ alias }) => alias === planAlias);
}

export function usePlansHierarchy(filters?: IFilterPlansProps): IPlanParent[] {
  const { plansHierarchy } = useContext(PlansContext);

  if (filters) {
    return plansHierarchy.map((planHierarchy) => ({
      ...planHierarchy,
      plans: filterPlans(planHierarchy.plans, filters),
    }));
  }

  return plansHierarchy;
}

export function useIsPlanValid(alias: string): boolean {
  return !!usePlan({ alias });
}
